import data from '../content/testimonials.json';

export interface Testimonial {
  id: string;
  quote: string;
  name: string;
  relation?: string;
  featured?: boolean;
}

export interface TestimonialsContent {
  version: number;
  headline: string;
  intro: string;
  items: Testimonial[];
}

export function getTestimonials(): TestimonialsContent {
  return data as TestimonialsContent;
}

export function featuredTestimonials(limit = 4): Testimonial[] {
  const all = getTestimonials().items;
  const featured = all.filter((t) => t.featured);
  return (featured.length ? featured : all).slice(0, limit);
}
